import Loading from "../../components/Loading";
import PageLayout from "../../layouts/PageLayout";
import MoneyReceiptStep from "./MoneyReceiptStep/MoneyReceiptStep";
import { useGetRouteState } from "../../utils/route.utils";

export default function MoneyReceiptAddPage({ editItem }) {
  const { data: existCustomer, redirectTo } = useGetRouteState();

  const id = editItem?.id ?? "";

  const isLoading = false;

  const title = `${!!id ? "Edit" : "Add"} Money Receipt`;

  const breadCrumbs = [
    {
      name: "Money Receipt",
      link: redirectTo ?? "/money-receipt-list"
    },
    {
      name: title
    }
  ];

  return (
    <PageLayout title={title} breadCrumbs={breadCrumbs}>
      {<Loading loading={isLoading} />}
      <MoneyReceiptStep
        title={title}
        editItem={editItem}
        existCustomer={existCustomer}
        redirectTo={redirectTo}
      />
    </PageLayout>
  );
}
